import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { SelectCustom } from '../../../common/selectCustom'
import { DISPLAY_OPTIONS, DISPLAY_TYPES } from '../constants'
import { changeDisplayType, selectDisplayType } from '../store/slice'

const DisplayType = () => {
  const dispatch = useDispatch()
  const displayType = useSelector(selectDisplayType)

  const chooseItem = (item) => {
    dispatch(changeDisplayType(item.value))
  }

  return (
    <Element
      className={'dFlex alignItemsCenter fw600'}
      style={{ marginTop: 5 }}
    >
      <Element style={{ fontSize: 14 }} className="pr2">
        <Translate value={'portfolio.finance.DISPLAY_TYPE'} />
      </Element>
      <SelectCustom
        chooseItem={chooseItem}
        activeItem={{
          value: displayType,
          label: `portfolio.finance.${Object.keys(DISPLAY_TYPES).find(
            (key) => DISPLAY_TYPES[key] === displayType,
          )}`,
        }}
        data={DISPLAY_OPTIONS}
        isI18n={true}
        renderActiveItem={(item) => (
          <Element style={{ color: '#0553A5' }}>
            <Translate value={item.label} />
          </Element>
        )}
        iconNoPosition
        className="dFlex justifyContentBetween"
        iconWhenShowDropList="icon-arrow-top-bold"
        iconWhenHiddenDropList="icon-arrow-bottom-bold"
        style={{
          borderColor: 'transparent',
          borderBottom: '1px solid #9C9C9C',
          borderRadius: 0,
          padding: '6px 0 4px',
          gap: 6,
        }}
      />
    </Element>
  )
}

export default DisplayType
